module.exports = __webpack_public_path__ + "static/media/export.244a4faa.svg";